import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatBadgeModule } from '@angular/material/badge';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { LoadingBoxDefaultListComponent } from '../../../../../shared/components/loading-box-default-list/loading-box-default-list.component';
import { EmptyListComponent } from '../../../../../shared/components/empty-list/empty-list.component';
import { ModuloEnum } from '../../../../../shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '../../../../../shared/enums/usuario/funcionalidade.enum';
import { PedidoExtracaoService } from '../../../../../shared/services/apis/batch-extracao-dados/pedido-extracao.service';
import { AlertService, AlertType } from '../../../../../shared/services/alert.service';
import { ListPedidoExtracaoResponse } from '../../../../../shared/services/responses/batch-extracao-dados/list-pedido-extracao.response';
import { PedidoExtracaoStruct } from '../../../../../shared/services/structs/batch-extracao-dados/pedido-extracao.struct';
import { BatchExtracaoDadosLookupService } from '../../../../../shared/services/apis/batch-extracao-dados/batch-extracao-dados-lookup.service';
import { BatchExtracaoDadosLookupResponse } from '../../../../../shared/services/responses/batch-extracao-dados/batch-extracao-dados-lookup.response';
import { TipoExtracao } from '../../../../../shared/services/models/batch-extracao-dados/tipo-extracao.model';
import { StatusExtracao } from '../../../../../shared/services/models/batch-extracao-dados/status-extracao.model';
import { SelectPesquisavelComponent } from '../../../../../shared/components/select-pesquisavel/select-pesquisavel.component';
import { StatusExtracaoEnum } from '../../../../../shared/enums/batch-extracao-dados/status-extracao.enum';
import { HeaderComponent } from '../../../../../shared/components/header/header.component';

@Component({
    selector: 'app-minhas-exportacoes',
    standalone: true,
    imports: [
        CommonModule,
        RouterModule,
        MatTableModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatButtonModule,
        MatIconModule,
        MatChipsModule,
        MatTooltipModule,
        MatMenuModule,
        MatBadgeModule,
        FormsModule,
        ReactiveFormsModule,
        LoadingBoxDefaultListComponent,
        EmptyListComponent,
        SelectPesquisavelComponent,
        MatProgressSpinnerModule,
        HeaderComponent
    ],
    templateUrl: './minhas-exportacoes.component.html',
    styleUrl: './minhas-exportacoes.component.css'
})
export class MinhasExportacoesComponent implements OnInit {

    public displayedColumns: string[] = ['id', 'tipo', 'dataHora', 'status', 'mensagem', 'actions'];
    public dataSource = new MatTableDataSource<PedidoExtracaoStruct>();
    public formFiltro: FormGroup;
    public isLoading = false;
    public moduloEnum: ModuloEnum;
    public funcionalidadeEnum: FuncionalidadeEnum;
    public statusExtracaoEnum = StatusExtracaoEnum;

    public _ultimaPagina = false;
    public _listaPedidoExtracaoResponse: ListPedidoExtracaoResponse | undefined;
    public _paginaAtual = 0;
    public idTipoExtracao: number[];
    public idStatusExtracao: number[];
    public listTipoExtracao: TipoExtracao[];
    public listStatusExtracao: StatusExtracao[];

    constructor(
        private fb: FormBuilder,
        private pedidoExtracaoService: PedidoExtracaoService,
        private alertService: AlertService,
        private batchExtracaoDadosLookupService: BatchExtracaoDadosLookupService
    ) { }

    ngOnInit(): void {
        this.formFiltro = this.fb.group({
            idTipoExtracao: [[]],
            idStatusExtracao: [[]]
        });

        this.moduloEnum = ModuloEnum.Home;
        this.funcionalidadeEnum = FuncionalidadeEnum.Home_Ferramentas;

        this.getLookup();
        this.loadData();
    }

    loadData() {
        if (this.isLoading) return;

        this.idTipoExtracao = this.formFiltro.value.idTipoExtracao || [];
        this.idStatusExtracao = this.formFiltro.value.idStatusExtracao || [];

        this.isLoading = true;
        this.pedidoExtracaoService.getAll(this.idTipoExtracao, this.idStatusExtracao, this._paginaAtual).subscribe({
            next: (response: ListPedidoExtracaoResponse) => {
                this.isLoading = false;
                if (response.isError) {
                    this.alertService.show('Aviso', response.errorDescription, AlertType.error);
                    return;
                }

                // Pagination Logic
                if (!response.listPedidoExtracao || response.listPedidoExtracao.length === 0) {
                    this._ultimaPagina = true;
                }

                if (!this._listaPedidoExtracaoResponse) {
                    this._listaPedidoExtracaoResponse = response;
                    this.dataSource.data = response.listPedidoExtracao;
                } else {
                    this._listaPedidoExtracaoResponse.listPedidoExtracao.push(...response.listPedidoExtracao);
                    this.dataSource.data = this._listaPedidoExtracaoResponse.listPedidoExtracao;
                }

                if (response.listPedidoExtracao.length === 0) {
                    this._ultimaPagina = true;
                }
            },
            error: (error) => {
                this.isLoading = false;
                this.alertService.show('Erro inesperado', error.message || 'Falha ao carregar automações', AlertType.error);
            }
        });
    }

    clickPesquisar(): void {
        this._paginaAtual = 0;
        this._listaPedidoExtracaoResponse = undefined;
        this.dataSource.data = [];
        this._ultimaPagina = false;
        this.loadData();
    }

    aplicarFiltros(): void {
        this.clickPesquisar();
    }

    limparFiltros(): void {
        this.formFiltro.patchValue({
            idTipoExtracao: [],
            idStatusExtracao: []
        });
        this.clickPesquisar();
    }

    get qtdFiltrosAvancados(): number {
        let count = 0;
        const formValue = this.formFiltro.getRawValue();
        if (formValue.idTipoExtracao?.length > 0) count++;
        if (formValue.idStatusExtracao?.length > 0) count++;
        return count;
    }

    download(element: PedidoExtracaoStruct) {
        if (element.statusLink === 'EXPIRADO') {
            this.alertService.show('Link Expirado', 'Este arquivo não está mais disponível.', AlertType.warning);
            return;
        }

        if (element.pedidoExtracao.urlArquivo) {
            window.open(element.pedidoExtracao.urlArquivo, '_blank');
        }
    }

    getStatusClass(idStatusExtracao: number): string {
        switch (idStatusExtracao) {
            case StatusExtracaoEnum.ProcessadoComSucesso:
                return 'badge-verde';
            case StatusExtracaoEnum.AguardandoProcessamento:
                return 'badge-cinza';
            case StatusExtracaoEnum.EmProcessamento:
                return 'badge-amarelo';
            case StatusExtracaoEnum.ProcessadoComErro:
                return 'badge-vermelho';
            default: return '';
        }
    }

    proximaPagina(): void {
        this._paginaAtual++;
        this.loadData();
    }

    getLookup() {
        this.batchExtracaoDadosLookupService.get().subscribe({
            next: (response: BatchExtracaoDadosLookupResponse) => {
                if (response.isError) {
                    this.alertService.show('Aviso', response.errorDescription, AlertType.error);
                    return;
                }

                this.listTipoExtracao = response.listTipoExtracao;
                this.listStatusExtracao = response.listStatusExtracao;
            },
            error: (error) => {
                this.alertService.show('Erro inesperado', error.message || 'Falha ao carregar lookup', AlertType.error);
            }
        });
    }

    public get idTipoExtracaoControl(): FormControl { return this.formFiltro.get('idTipoExtracao') as FormControl; }
    public get idStatusExtracaoControl(): FormControl { return this.formFiltro.get('idStatusExtracao') as FormControl; }
}
